import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, UntypedFormArray } from '@angular/forms';

@Pipe({
    name: 'formArrayLength',
    standalone: false
})
export class FormArrayLengthPipe implements PipeTransform {

	transform(value: AbstractControl | null): number {
		if (!value) {
			return 0;
		}

		if (!(value instanceof UntypedFormArray)) {
			return 0;
		}
		const formArray = value as UntypedFormArray;

		return formArray.controls.length;
	}

}
